import { bucketTime, convertServerDateToLocalDate, isToday, isTomorrow } from '@/lib/utils'
import { computed, type Ref } from 'vue'

export function useAppointmentDateTime(day: Ref<string>, time: Ref<string>) {
    const appointmentDate = computed(() => {
        if (!day.value || !time.value) return null
        return convertServerDateToLocalDate(`${day.value} ${time.value}`)
    })

    const formattedDate = computed(() => {
        const date = appointmentDate.value
        if (!date) return ''
        
        const now = new Date()
        const diffInMs = Math.abs(date.getTime() - now.getTime())
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
        
        const monthDay = date.toLocaleString('en-US', { month: 'short', day: 'numeric' })
        
        if (isToday(date)) {
            return `${monthDay} (Today)`
        } else if (isTomorrow(date)) {
            return `${monthDay} (Tomorrow)`
        } else if (diffInDays <= 7) {
            const weekday = date.toLocaleString('en-US', { weekday: 'short' })
            return `${monthDay}, ${weekday}`
        } else {
            const year = date.toLocaleString('en-US', { year: 'numeric' })
            return `${monthDay}, ${year}`
        }
    })

    const formattedTime = computed(() => {
        const date = appointmentDate.value
        if (!date) return ''

        const timeString = date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
        const bucketedTime = bucketTime(timeString.split(' ')[0])
        return `${bucketedTime} ${timeString.split(' ')[1]}`
    })

    return {
        appointmentDate,
        formattedDate,
        formattedTime
    }
}